import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useRemoveQueryParams } from 'js/hooks/navigate';

export const useJumioVerifyStatus = () => {
    const { search } = useLocation();
    const [verifyStatus, setStatus] = useState(null);
    const removeQueryParams = useRemoveQueryParams();

    useEffect(() => {
        const params = new URLSearchParams(search);
        const status = params.get('jumioVerify');

        setStatus(status);

        if (status == null) {
            return;
        }

        removeQueryParams(['jumioVerify']);
    }, [search, removeQueryParams]);

    return verifyStatus;
};
